function tileSlider() { 

  if(typeof slickOverride == 'function') {    
    // $(this).slick( 'slickSetOption', slickOverride(), true );

    slickOverride();
  } else {
    if($(".tile-slider").length > 0) {
      $(".tile-slider").each(function(){
        $(this).slick({
          dots: false,
          autoplay: false,
          infinite: true,
          arrows: true,
          fade: true,
        });   
        
      });
    }
  }  
  // console.log($(".tile-slider").length);
}

tileSlider();